import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { updateRockerboxWotcRoute } from '../api/constant';
import { rockerboxEmployerKey } from '../constants';

type useUpdateWotcStatusProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateWotcStatus = ({
    setErrorText = () => { },
}: useUpdateWotcStatusProps) => {
    const client = useQueryClient();

    const { mutate: updateWotcStatus, isLoading: isUpdateWotcStatusLoading } =
        useMutation({
            mutationFn: (variables: {
                wotc_enabled: string;
                company_id: number | string
            }) =>
                axiosInstance
                    .post(updateRockerboxWotcRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                setErrorText('');
                client.invalidateQueries([rockerboxEmployerKey]);
            },
            onError: () => {
                setErrorText(errorMessage);
            },
        });

    return {
        updateWotcStatus,
        isUpdateWotcStatusLoading,
    };
};
